<template>
    <div>
        <h2 class="mb-3">¿Está seguro de enviar el/los aviso/sos?</h2>
        <h4 v-if="sonAbonos">Cuando le des a 'enviar aviso', se le enviará un correo al/los abonado/os y AUTOMÁTICAMENTE SE LES DARÁ DE BAJA SU ABONO hasta que PAGUEN LOS PLAZOS FALLIDOS DEFINITIVOS, una vez pagados, se les dará de ALTA DE FORMA AUTOMÁTICA.</h4>
        <div class="mt-3">
            <Button class="mr-2" @click="terminar">Enviar</Button>
            <Button @click="close">Cancelar</Button>
        </div>
        <LoaderComponent v-if="loading"/>
    </div>
</template>

<script>
    export default {
        props: ['sonAbonos', 'loading'],
        methods: {
            terminar() {
                this.$emit('terminar');
            },
            close() {
                this.$emit('close');
            }
        }
    }
</script>